"use client";

import React, { FC, MouseEventHandler, forwardRef, useMemo } from "react";

import { HamburgerMenuProps } from "@/types";

import "./HamburgerMenu.css";

/* const HamburgerMenu: FC<HamburgerMenuProps> = ({ variant, onClick }) => {
  const buttonVariant = useMemo(() => {
    return variant === "dark" ? "bg-black" : "bg-white";
  }, [variant]);
  return (
    <button aria-label={`Menu`} className="space-y-xxs p-s" onClick={onClick as MouseEventHandler}>
      <span className={`block h-1 w-m ${buttonVariant}`}></span>
      <span className={`block h-1 w-m ${buttonVariant}`}></span>
      <span className={`block h-1 w-m ${buttonVariant}`}></span>
    </button>
  );
}; */

const HamburgerMenu = forwardRef<HTMLButtonElement, HamburgerMenuProps>(({ variant, onClick }, ref) => {
  const buttonVariant = useMemo(() => {
    return variant === "dark" ? "bg-black" : "bg-white";
  }, [variant]);
  return (
    <button ref={ref} aria-label={`Menu`} className="menu-lines p-s" onClick={onClick as MouseEventHandler}>
      <span className={`block menu-line first-line ${buttonVariant}`}></span>
      <span className={`block menu-line ${buttonVariant}`}></span>
      <span className={`block menu-line third-line ${buttonVariant}`}></span>
    </button>
  );
});

HamburgerMenu.displayName = "HamburgerMenu";
export default HamburgerMenu;
